import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a low two-shelf shoe rack (0.8 x 0.3 x 0.5) with three pairs
// of shoes as small paired boxes in muted colours.
const OAK = "#c8975a";
const WALNUT = "#7a5a3a";
const BLACK = "#2e2e30";
const BRICK = "#a05a40";
const BLUE = "#8a9aa8";

export const shoeRack = defineModel({
  id: "shoe-rack",
  batchId: "modern",
  name: "Shoe rack",
  tags: ["modern", "interior", "furniture", "hallway", "storage", "shoes"],
  summary: "A low oak shoe rack with two shelves of shoes.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // side panels
      { geometry: new THREE.BoxGeometry(0.03, 0.5, 0.3), color: OAK, position: [-0.385, 0.25, 0] },
      { geometry: new THREE.BoxGeometry(0.03, 0.5, 0.3), color: OAK, position: [0.385, 0.25, 0] },
      // shelves + top
      { geometry: new THREE.BoxGeometry(0.74, 0.03, 0.28), color: OAK, position: [0, 0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.74, 0.03, 0.28), color: OAK, position: [0, 0.32, 0] },
      { geometry: new THREE.BoxGeometry(0.74, 0.03, 0.28), color: WALNUT, position: [0, 0.485, 0] },
      // pair of black shoes (lower shelf, left)
      { geometry: new THREE.BoxGeometry(0.09, 0.07, 0.24), color: BLACK, position: [-0.22, 0.15, 0] },
      { geometry: new THREE.BoxGeometry(0.09, 0.07, 0.24), color: BLACK, position: [-0.11, 0.15, 0] },
      // pair of brick shoes (lower shelf, right)
      { geometry: new THREE.BoxGeometry(0.09, 0.07, 0.24), color: BRICK, position: [0.13, 0.15, 0] },
      { geometry: new THREE.BoxGeometry(0.09, 0.07, 0.24), color: BRICK, position: [0.24, 0.15, 0] },
      // pair of blue-grey shoes (upper shelf)
      { geometry: new THREE.BoxGeometry(0.09, 0.07, 0.24), color: BLUE, position: [-0.06, 0.37, 0] },
      { geometry: new THREE.BoxGeometry(0.09, 0.07, 0.24), color: BLUE, position: [0.05, 0.37, 0] },
    ];
  },
  animations: [],
});
